/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  OrganizationPaymentCardInfo,
  OrganizationPaymentCardInfoFromJSON,
  OrganizationPaymentCardInfoFromJSONTyped,
  OrganizationPaymentCardInfoToJSON
} from './OrganizationPaymentCardInfo'

/**
 *
 * @export
 * @interface UserV1OrganizationPaymentBillingInfoRetrievePaymentMethodPaymentMethodIdGet200ResponseData
 */
export interface UserV1OrganizationPaymentBillingInfoRetrievePaymentMethodPaymentMethodIdGet200ResponseData {
  /**
   *
   * @type {string}
   * @memberof UserV1OrganizationPaymentBillingInfoRetrievePaymentMethodPaymentMethodIdGet200ResponseData
   */
  id: string
  /**
   *
   * @type {OrganizationPaymentCardInfo}
   * @memberof UserV1OrganizationPaymentBillingInfoRetrievePaymentMethodPaymentMethodIdGet200ResponseData
   */
  card: OrganizationPaymentCardInfo
}

export function UserV1OrganizationPaymentBillingInfoRetrievePaymentMethodPaymentMethodIdGet200ResponseDataFromJSON(
  json: any
): UserV1OrganizationPaymentBillingInfoRetrievePaymentMethodPaymentMethodIdGet200ResponseData {
  return UserV1OrganizationPaymentBillingInfoRetrievePaymentMethodPaymentMethodIdGet200ResponseDataFromJSONTyped(
    json,
    false
  )
}

export function UserV1OrganizationPaymentBillingInfoRetrievePaymentMethodPaymentMethodIdGet200ResponseDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UserV1OrganizationPaymentBillingInfoRetrievePaymentMethodPaymentMethodIdGet200ResponseData {
  if (json === undefined || json === null) {
    return json
  }
  return {
    id: json['id'],
    card: OrganizationPaymentCardInfoFromJSON(json['card'])
  }
}

export function UserV1OrganizationPaymentBillingInfoRetrievePaymentMethodPaymentMethodIdGet200ResponseDataToJSON(
  value?: UserV1OrganizationPaymentBillingInfoRetrievePaymentMethodPaymentMethodIdGet200ResponseData | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    id: value.id,
    card: OrganizationPaymentCardInfoToJSON(value.card)
  }
}
